import { isSdkLocale, showView } from '@modules/brillen-sdk'
import { resolveDevToggle, useDevToggles } from 'hooks/dev/useDevToggles'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { usePathname } from 'expo-router'

export const MeasurementLocation = {
  vision: 'vision_values',
  prescription: 'prescription_form',
  eyetest: 'eyetest',
  frameSh: 'frame_settings_sh',
} as const

export type MeasurementLocationType =
  (typeof MeasurementLocation)[keyof typeof MeasurementLocation]

function useMeasureSdk(type: 'pd' | 'sh', location?: MeasurementLocationType) {
  const { i18n, t } = useTranslation(['measurement'])
  const pathname = usePathname()

  const measurementsMock = useDevToggles((s) => s.measurementsMock)
  const locale = isSdkLocale(i18n.language) ? i18n.language : 'en'
  const sdkTls = t('measurement:sdk', {
    returnObjects: true,
  })

  const onMeasure = useCallback(
    (args?: { manual?: boolean }) => {
      const isManual = args?.manual
      const mock =
        isManual !== undefined
          ? isManual
          : resolveDevToggle(measurementsMock, false)

      showView({
        type,
        locale,
        mock,
        translations: sdkTls,
        location: location || 'unknown',
        pathname,
      })
    },
    [measurementsMock, locale, sdkTls, type, location, pathname]
  )

  return {
    onMeasure,
  }
}

export default useMeasureSdk
